// The withheld-composite disclosure (owner rulings OR-UNI-20261004-01): "Composite withheld — missing: <axis>
// (<reason>)" built ONLY from the server's composite_missing_axes (the ACOS axis taxonomy over the same canonical
// aggregate). No reason is invented here: an axis without a recorded reason is not listed, and with nothing listed
// there is no line at all.
export interface MissingAxis { id: string; label: string; state?: string; code?: string; reason: string }

export function parseMissingAxes(raw: unknown): MissingAxis[] {
  if (!Array.isArray(raw)) return [];
  return raw.filter((m): m is MissingAxis => !!m && typeof m === 'object'
    && typeof (m as MissingAxis).label === 'string' && (m as MissingAxis).label.trim() !== ''
    && typeof (m as MissingAxis).reason === 'string' && (m as MissingAxis).reason.trim() !== '');
}

export function compositeMissingText(raw: unknown): string | null {
  const list = parseMissingAxes(raw);
  if (list.length === 0) return null;
  return `Composite withheld — missing: ${list.map((m) => `${m.label} (${m.reason})`).join(', ')}`;
}
